export const GET_PRODUCTS = 'GET_PRODUCTS'
export const SELECT_CATEGORY = 'SELECT_CATEGORY'
export const SET_LOADING = 'SET_LOADING'
export const SET_SEARCH = 'SET_SEARCH'
export const UPDATE_PRODUCTS = 'UPDATE_PRODUCTS'
export const RESET = 'RESET'
export const SET_RATE = 'SET_RATE'
export const SET_SORT = 'SET_SORT'
export const SORT_PRODUCTS = 'SORT_PRODUCTS'
export const FILTER_RATE_PRODUCTS = 'FILTER_RATE_PRODUCTS'


export const ADD_TO_CART = 'ADD_TO_CART'
export const DELETE_TO_CART = 'DELETE_TO_CART'
export const EMPTY_CART = 'EMPTY_CART'
export const EDIT_QTY = 'EDIT_QTY'